import script from "./WalletList.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletList.vue?vue&type=script&setup=true&lang=js"

import "./WalletList.vue?vue&type=style&index=0&id=438b57e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438b57e0"]])

export default __exports__